var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"dialog":!!_vm.component,"header":_vm.title},on:{"onClose":_vm.handleClose}},[_c(_vm.component,{tag:"component",attrs:{"props":_vm.props,"success-fn":_vm.onSuccess},on:{"onClose":_vm.handleClose}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c644026","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/smallComponents/Dialog/DialogRoot.vue
// module id = null
// module chunks = 